import { requestApi } from './Api';

export const getBalance = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/transaction/balance',
    params
  });

export const readBalance = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/patient/balance/read',
    params
  });

export const unAllocateBalance = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/patient/balance/unallocate',
    params
  });

export const deleteWriteOff = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/writeoff/remove',
    params
  });

export const getInvoices = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/appointment/invoices/get',
    params
  });

export const getInvoicesCSV = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/appointment/invoices/get_csv',
    params
  });

export const getTransactions = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/list',
    params
  });

export const getAllTransactions = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/list_all',
    params
  });

export const recheckTransaction = (navigate, params) =>
  requestApi({ navigate, url: 'api/transactions/recheck', params });

export const getTransactionsCSV = (navigate, params) =>
  requestApi({ navigate, url: '/api/transactions/get_csv', params });

export const calculateBalance = (navigate, params) =>
  requestApi({
    params,
    navigate,
    url: '/api/patient/transaction/calculate_balance'
  });

export const getTransactionActivities = (navigate, params) =>
  requestApi({
    url: '/api/transactions/activity/get',
    params,
    navigate
  });

export const terminalTransactionInitiate = (navigate, params) =>
  requestApi({
    url: '/api/transactions/terminal/transaction/initiate',
    params,
    navigate
  });

export const fixInvoicesAndBalance = (navigate, params) =>
  requestApi({
    params,
    navigate,
    url: '/api/patient/transaction/fix_invoices_and_balance'
  });
